import { useEffect, useRef, useState, Node } from 'react';
import get from 'lodash/get';

import { createScript } from '@vmos2/utils';

type Props = {
  children: Node,
  apiKey: string,
};

export const GoogleMapsProvider = ({ children, apiKey }: Props) => {
  const isLoading = useRef(false);
  const [ready, setReady] = useState(!!get(window, 'google.maps'));

  useEffect(() => {
    (async () => {
      if (!isLoading.current && !ready && apiKey) {
        isLoading.current = true;
        await createScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=en&libraries=places,marker`);
        setReady(true);
      }
    })();
  }, [isLoading, apiKey]);

  if (apiKey && !ready) {
    return null;
  }

  return children;
};
